import request from '@/request'
import store from '@/store'
import CONSTANTS from '@/constants'
const state = {
}

const mutations = {

}

const actions = {
    getLikes({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/get_like_list',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    lookAtMe({ commit }, params) {
        let pointSetting = null
        store.dispatch('user/getPointFee', {
            token: store.getters.defaultToken
        }).then(data => {
            pointSetting = data
            let sub_point_look_at_me = pointSetting.result.filter(item => {
                return item.slug === 'send_look_at_me' && parseInt(item.type) === CONSTANTS.SUB_ACTION_POINT
            })
            if (sub_point_look_at_me[0] && parseInt(pointSetting.balance) >= parseInt(sub_point_look_at_me[0].point)) 
            return new Promise((resolve, reject) => {
                request({
                    url: '/user/look_at_me',
                    method: 'post',
                    data: params
                }).then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                })
            }) 
            else {
                window.location="/profile/buy-point"
            }
        }).catch(err => {
            console.log(err)
        })
        
    },
}

export default {
    namespaced: true,
    actions,
    mutations,
    state
}